module.exports = __webpack_public_path__ + "img/alert.163cfadb.svg";